/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Priority_MediumInputs */

const en_priority_medium = /** @type {(inputs: Priority_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medium`)
};

const de_priority_medium = /** @type {(inputs: Priority_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittel`)
};

/**
* | output |
* | --- |
* | "Medium" |
*
* @param {Priority_MediumInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const priority_medium = /** @type {((inputs?: Priority_MediumInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Priority_MediumInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_priority_medium(inputs)
	return en_priority_medium(inputs)
});